import React, { createRef, useMemo, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EditAttributes, Visibility, Edit } from '@material-ui/icons';
import moment from 'moment';
import { UnidataTable, Modal } from '~/components';

import { includes } from 'lodash';

import { ADM, GFO, GFU } from '~/constants/perfil';

import {
  operacaoImpedimentosInRequest,
  deleteOperacaoImpedimentos,
  findOperacaoImpedimentos,
  recordFiltering,
} from '~/store/modules/operacaoimpedimentos/actions';

import ListaImpedimentos from './components/ListaImpedimentos';
import OperacaoImpedimentosForm from './form';

function OperacaoImpedimentosLista() {

  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState({})

  const operacaoimpedimentos = useSelector((state) => state.operacaoimpedimentos);

  const operacaoImpedimentosRef = createRef(null)
  const listaImpedimentosRef = createRef(null);
  const modalRef = createRef(null)

  const { glousuariotipo, gloperfilid } = useSelector(
    (state) => state.user.profile
  );


  async function handleUpdate() {
    await dispatch(recordFiltering(operacaoimpedimentos.params));
  }
  const header = useMemo(() => [
    {
      id: 'veic_placa_apresentacao',
      label: 'Veículo',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'usua_nome',
      label: 'Nome',
      align: 'left',
    },
    {
      id: 'usua_login',
      label: 'Login',
      align: 'right',
    },
    {
      id: 'imab_codigo',
      label: 'Cód Liberação',
      align: 'left',
    },

    {
      id: 'poco_codigo',
      label: 'Cód Posto',
      align: 'left',
    },
    {
      id: 'poco_desc_abrev',
      label: 'Posto',
      align: 'right',
    },
    {
      id: 'unid_codigo',
      label: 'Cód Unidade',
      align: 'right',
    },
    {
      id: 'orga_codigo',
      label: 'Cód Orgao',
      align: 'left',
    },
    {
      id: 'cond_cpf',
      label: 'CPF Condutor',
      align: 'right',
    },
    {
      id: 'cond_nome',
      label: 'Condutor',
      align: 'left',
    },
    {
      id: 'imab_data_registro',
      label: 'Data Registro',      
      formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      align: 'right',
    },
    {
      id: 'imab_data_liberacao',
      label: 'Data Liberação',      
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-'),
      align: 'right',
    },
    {
      id: 'imab_tipo',
      label: 'Tipo',
      align: 'left',
    },
    {
      id: 'imab_liberado',
      label: 'Liberado',
      align: 'left',
    },
    {
      id: 'imab_horas_validade',
      label: 'Horas',
      align: 'right',
    },
    {
      id: 'imab_obs',
      label: 'OBS',
      align: 'right',
    },
  ], [])

  const buttons = useMemo(() => {

    let buttonsArray = []

    buttonsArray.push({
      title: 'Lista de Impedimentos',
      action: (value) => listaImpedimentosRef.current.handleToggleModal(value),
      icon: <Visibility />,
    })

    selectedItem.imab_liberado != 'L' &&
      includes([ADM, GFO, GFU], gloperfilid) && buttonsArray.push({
        title: 'Editar',
        action: (value) => modalRef.current.handleOpenModal({ data: value, reference: operacaoImpedimentosRef, modal: modalRef }),
        icon: <Edit />,
    })

    return buttonsArray
  }, [operacaoImpedimentosRef, listaImpedimentosRef, selectedItem, gloperfilid])

  const handleAfterClosingModal = useCallback(() => {
    dispatch(recordFiltering(operacaoimpedimentos.params));
  }, [operacaoimpedimentos.params]);

  const handleChangeRow = useCallback((value) => {
    setSelectedItem(value)
  }, [operacaoimpedimentos])

  return (
    <>

      <UnidataTable
        fixed
        header={header}
        redux={operacaoimpedimentos}
        actions={buttons}
        read={recordFiltering}
        remove={deleteOperacaoImpedimentos}
        find={findOperacaoImpedimentos}
        create={false}
        update={false}
        detach="imab_codigo"
        keys="imab_codigo"
        onRow={handleChangeRow}
      />


      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title="Cadastro de Veículo"
        maxWidth="sm"
        fullScreen={window.innerWidth <= 425}
        component={OperacaoImpedimentosForm}
        onClose={handleAfterClosingModal}
      />


      {/* <Tabela
        read={operacaoImpedimentosInRequest}
        remove={deleteOperacaoImpedimentos}
        state={operacaoimpedimentos}
        header={header}
        noCreate
        //noEdition
        headerMobile="imab_codigo"
        unique={['imab_codigo']}
        form={OperacaoImpedimentosForm}
        findItem={findOperacaoImpedimentos}
        recordFilter={recordFiltering}
        buttons={buttons}
        // customFilter={[
        //   {
        //     id: 'data_cadastro_ini',
        //     name: 'data_cadastro_ini',
        //     label: 'Data Inicial',        
        //     type: 'initialdatetime',
        //   },
        //   {
        //     id: 'data_cadastro_fim',
        //     name: 'data_cadastro_fim',
        //     label: 'Data final',        
        //     type: 'finaldatetime',
        //   },
        //   {
        //     id: 'veic_placa_apresentacao',
        //     label: 'Veículo',           
        //     type: 'text',            
        //   },
        // ]}

      /> */}

      <ListaImpedimentos ref={listaImpedimentosRef} update={() => handleUpdate()} name="teste" />
    </>
  );
}

export default OperacaoImpedimentosLista;
